export default {
	COMMAND_RESPONSE: 'command-response',
	COMMAND_ODOMETER_RESPONSE: 'command-odometer-response',
	LIVE_STREAMING: 'live-streaming',
};
